module.exports = __webpack_public_path__ + "../resources/images/logo-service-monochrome-b49adab93304776084f09ed493b5c221.svg";